import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";

@Component({
  selector: "ngx-call-support",
  templateUrl: "./call-support.component.html",
  styleUrls: ["./call-support.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallSupportComponent extends BaseFormComponent<any> {
  CallSupport: any[] = [
    { Id: 9, title: this.translate("ClientApp.FrontOffice.Order.OrderOnline.CallSupport.PriceDifferenceWithMenu") },
    { Id: 10, title: this.translate("ClientApp.FrontOffice.Order.OrderOnline.CallSupport.AddressProblem") },
    { Id: 11, title: this.translate("ClientApp.FrontOffice.Order.OrderOnline.CallSupport.CourierFee") },
    { Id: 12, title: this.translate("ClientApp.FrontOffice.Order.OrderOnline.CallSupport.FoodIsOver") },
    { Id: 13, title: this.translate("ClientApp.FrontOffice.Order.OrderOnline.CallSupport.CustomerInformation") },
    { Id: 14, title: this.translate("ClientApp.FrontOffice.Order.OrderOnline.CallSupport.OtherReasons") },
  ];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.FillData();
  }

  FillData() {
    this.columns = [];
    const newGroup: any = {};
    // newGroup['test'] = new FormControl('');
    this.formGroup = new UntypedFormGroup(newGroup);
    this.setValue("callSupportId", "");
  }
  public async save() {
    this.result = this.formGroup.controls["callSupportId"].value;
    this.close();
  }
}
